// src/pages/FemaleRosterPage.jsx
import { Link } from "react-router-dom";
import { usePlayersByGroup } from "../hooks/usePlayers";
import RosterSkeleton from "../components/RosterSkeleton";
import PlayerPhoto from "../components/PlayerPhoto";
import FemaleHero from "../assets/divisions/female.jpeg";

function FemaleRosterPage() {
  const { players: femalePlayers, loading } = usePlayersByGroup("female");

  return (
    <main className="bg-black min-h-screen">
      {/* Hero Section */}
      <section className="relative h-[50vh] min-h-[400px] flex items-center justify-center">
        <div className="absolute inset-0">
          <img src={FemaleHero} alt="Female Division" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-black via-black/70 to-black/40"></div>
          <div className="absolute inset-0 bg-gradient-to-r from-red-900/20 to-transparent"></div>
        </div>
        <div className="relative z-10 text-center px-6">
          <span className="text-red-500 text-sm font-semibold uppercase tracking-wider mb-2 block">
            Female Division
          </span>
          <h1 className="text-5xl md:text-7xl font-black uppercase tracking-tight text-white mb-4">
            Female <span className="text-red-600">Roster</span>
          </h1>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto">
            Representing Caribbean women in competitive gaming
          </p>
          <Link
            to="/roster"
            className="inline-flex items-center gap-2 mt-6 text-gray-400 hover:text-white transition-colors"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
            Back to Teams
          </Link>
        </div>
      </section>

      {/* Roster */}
      <section className="py-16 px-6">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-2xl font-bold text-white mb-8 uppercase border-l-4 border-red-600 pl-4">
            Female Division
          </h2>
          {loading && <RosterSkeleton count={2} />}

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {femalePlayers.map((player) => (
              <Link
                to={`/roster/${player.id}`}
                key={player.id}
                className="group bg-gray-900 border border-gray-800 rounded-lg overflow-hidden hover:border-red-600/50 transition-all duration-300 hover:shadow-lg hover:shadow-red-900/20"
              >
                {/* Player Image */}
                <div className="aspect-square overflow-hidden bg-gray-800">
                  <PlayerPhoto player={player} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                </div>

                {/* Info */}
                <div className="p-4">
                  <span className="text-red-500 text-xs font-semibold uppercase tracking-wider">
                    {player.division}
                  </span>
                  <h3 className="text-white font-bold text-lg mt-1 group-hover:text-red-400 transition-colors">
                    {player.name}
                  </h3>
                  <p className="text-gray-500 text-sm mt-1">{player.country}</p>
                  <p className="text-gray-600 text-xs mt-2 uppercase tracking-wide">
                    {player.specialization}
                  </p>
                </div>
              </Link>
            ))}
          </div>

          {!loading && femalePlayers.length === 0 && (
            <div className="text-center py-16">
              <p className="text-gray-500 text-lg">No players found in this division.</p>
            </div>
          )}
        </div>
      </section>
    </main>
  );
}

export default FemaleRosterPage;
